import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {Oauth2ClientService} from './oauth2-client.service';

export const Oauth2ClientResolver: ResolveFn<boolean> = () => {
  return inject(Oauth2ClientService).fetch();
};
